import PersonaOfficeShell from "@/components/PersonaOfficeShell";
import {
  Newspaper, UserCheck, Megaphone, Globe, IdCard, Search, MessagesSquare,
} from "lucide-react";

/** L9 · PR Agency dashboard.
 *  Sponsors journalist / influencer / paparazzi verifications.
 *  Owns media relations, coverage tracking, and press campaigns. */
const CONFIG = {
  layer:            "L9",
  label:            "PR Agency",
  testidPrefix:     "pr-office",
  accent:           "#22D3EE",
  Icon:             Newspaper,
  expectedOrgType:  "pr_agency",
  blurb:            "Sponsor journalists · run press campaigns · own the coverage trail for every film, brand and launch.",
  showSponsorQueue: true,
  sponsorLabel:     "Journalists · Influencers · Paparazzi",
  tiles: [
    {
      key: "pending", to: "/pending-individuals", TileIcon: UserCheck,
      title: "Pending Verifications",
      desc:  "Approve journalists/influencers/paparazzi who chose you as sponsor.",
      chip: "Live", chipTone: "live",
    },
    {
      key: "media-roster", to: "/directory?kind=journalist", TileIcon: Search,
      title: "Journalist Directory",
      desc:  "Every verified reporter, critic, YouTuber and podcaster on Call·Sheet.",
      chip: "Live", chipTone: "live",
    },
    {
      key: "campaigns", to: "/office/desks/campaign", TileIcon: Megaphone,
      title: "Press Campaigns",
      desc:  "Track PR campaigns per film / brand / launch — pitches, embargoes, deliverables.",
      chip: "Beta", chipTone: "beta",
    },
    {
      key: "coverage", TileIcon: MessagesSquare,
      title: "Coverage Tracker",
      desc:  "Clip archive · sentiment lens · reach numbers per outlet.",
      chip: "Soon", chipTone: "soon",
    },
    {
      key: "public-profile", to: "/office/public-profile", TileIcon: Globe,
      title: "Public Profile",
      desc:  "Your agency's public face — media kits, awards, retained clients.",
      chip: "Live", chipTone: "live",
    },
    {
      key: "icard", to: "/icard", TileIcon: IdCard,
      title: "Owner iCard",
      desc:  "Your verified, co-branded identity card.",
      chip: "Live", chipTone: "live",
    },
  ],
};

export default function PRAgencyDashboard() {
  return <PersonaOfficeShell config={CONFIG} />;
}
